import Microgame from '../engine/Microgame.js';

export default class ShootGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Tire !`, en: `Shoot!`, es: `¡Dispara!` },
            controls: { fr: `Appuie sur l'écran dès que la cible apparaît`, en: `Tap the screen as soon as the target appears`, es: `Toca la pantalla en cuanto aparezca el objetivo` },
            objective: { fr: `Abats la cible lumineuse le plus vite possible`, en: `Shoot down the glowing target as fast as possible`, es: `Derriba el objetivo brillante lo más rápido posible` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M12 12v.01"/><path d="m19.07 4.93-2.83 2.83"/><path d="m4.93 19.07 2.83-2.83"/><path d="m4.93 4.93 2.83 2.83"/><path d="m19.07 19.07-2.83-2.83"/><circle cx="12" cy="12" r="10"/></svg>`,
            actions: [
                { type: 'wait', duration: 520 },
                { type: 'tapTarget', selector: 'div[style*="crosshair"]', duration: 220 },
                { type: 'wait', duration: 420 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.target = null;
        this.vx = 0;
        this.vy = 0;
    }

    setup() {
        this.engine.ui.instruction.textContent = "SHOOT!";

        // Target
        this.target = document.createElement('div');
        this.target.style.position = 'absolute';
        this.target.style.width = '80px';
        this.target.style.height = '80px';
        this.target.style.background = `radial-gradient(circle, ${this.primaryColor} 30%, transparent 30%, ${this.primaryColor} 60%, transparent 60%, ${this.primaryColor} 100%)`;
        this.target.style.borderRadius = '50%';
        this.target.style.boxShadow = `0 0 20px ${this.primaryColor}`;
        this.target.style.cursor = 'crosshair';

        // Random Start Pos
        const x = Math.random() * (this.container.clientWidth - 80);
        const y = Math.random() * (this.container.clientHeight - 80);
        this.target.style.left = `${x}px`;
        this.target.style.top = `${y}px`;

        this.container.appendChild(this.target);

        // Random Velocity
        this.vx = (Math.random() * 400 + 200) * (Math.random() > 0.5 ? 1 : -1);
        this.vy = (Math.random() * 400 + 200) * (Math.random() > 0.5 ? 1 : -1);

        // Click Handler
        this.target.addEventListener('pointerdown', (e) => {
            if (!this.active) return;
            e.stopPropagation(); // Prevent miss click if we had one

            // Explosion effect
            this.target.style.transform = 'scale(2)';
            this.target.style.opacity = '0';
            this.target.style.transition = 'all 0.2s';

            this.win();
        });
    }

    update(dt) {
        if (!this.active) return;

        // Move Target
        const rect = this.target.getBoundingClientRect();
        const containerRect = this.container.getBoundingClientRect();

        let x = rect.left - containerRect.left + this.vx * (dt / 1000);
        let y = rect.top - containerRect.top + this.vy * (dt / 1000);

        // Bounce
        if (x <= 0 || x + rect.width >= containerRect.width) {
            this.vx *= -1;
            x = Math.max(0, Math.min(x, containerRect.width - rect.width));
        }
        if (y <= 0 || y + rect.height >= containerRect.height) {
            this.vy *= -1;
            y = Math.max(0, Math.min(y, containerRect.height - rect.height));
        }

        this.target.style.left = `${x}px`;
        this.target.style.top = `${y}px`;
    }
}
